import "../App.css"

const AILoadingText = () => (
  <div className="ai-loading">
    <span>AI 正在思考中</span>
    <span className="dots">
      <span className="dot"></span>
      <span className="dot" style={{ animationDelay: "0.2s" }}></span>
      <span className="dot" style={{ animationDelay: "0.4s" }}></span>
    </span>
  </div>
);


export default AILoadingText;